// extracted by mini-css-extract-plugin
export default {"container":"dWKf8t","containerBorder":"FhgDlP","header":"R_a8Kf","content":"mBivjd","controls":"sSnXPD"};